import { render, staticRenderFns } from "./UploadDiffAppConfig.vue?vue&type=template&id=0baa563a&scoped=true"
import script from "./UploadDiffAppConfig.vue?vue&type=script&lang=js"
export * from "./UploadDiffAppConfig.vue?vue&type=script&lang=js"
import style0 from "./UploadDiffAppConfig.vue?vue&type=style&index=0&id=0baa563a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa563a",
  null
  
)

export default component.exports